import { Link } from "react-router-dom";

export default function BonPlansMobile({ promoProducts }) {

  const formatPriceDT = (value) => {
    const isWhole = Number(value) % 1 === 0;
    return `${new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: isWhole ? 0 : 3,
      maximumFractionDigits: 3
    }).format(value)} DT`;
  };
  return (
    <div className="container-fluid px-0">
      {promoProducts.map((product) => {
        // Parse categories safely
        let categories = [];
        try {
          if (typeof product.category === "string") {
            categories = JSON.parse(product.category);
          } else if (Array.isArray(product.category)) {
            categories = product.category;
          } else if (product.category) {
            categories = [product.category];
          }
          if (!Array.isArray(categories)) {
            categories = [categories];
          }
        } catch {
          categories = product.category ? [product.category] : [];
        }

        return (
          <Link
            key={`${product.type}-${product.id}`}
            to={`/shop-details/${product.id}`}
            className="text-decoration-none"
          >
            <div
              className="card mb-3 shadow-sm border-0 rounded-4"
              style={{
                display: "flex",
                flexDirection: "column", // Stack vertically
                alignItems: "center",
                padding: "8px",
                marginRight: "80px",
                marginLeft: "-90px"
              }}
            >
              {/* IMAGE */}
              <div
                style={{
                  width: "100%",
                  height: "150px",
                  display: "flex",
                  marginLeft: "260px",
                  marginBottom: "10px",
                }}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  style={{
                    width: "80%", // image takes 80% width
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>

              {/* CONTENT */}
              <div style={{ width: "100%", textAlign: "center" }}>
                <h6 className="fw-bold text-dark mb-1">{product.name}</h6>

                {product.type === "variation" && (
                  <div
                    className="text-muted"
                    style={{ fontSize: "0.75rem", marginBottom: "4px" }}
                  >
                    {product.variation_name}
                  </div>
                )}

                {/* CATEGORIES */}
                {categories.length > 0 && (
                  <div className="d-flex flex-wrap justify-content-center gap-1 mb-2">
                    {categories.slice(0, 3).map((cat, i) => (
                      <span
                        key={i}
                        style={{
                          backgroundColor: "#f1f8e9",
                          color: "#558b2f",
                          fontSize: "0.65rem",
                          padding: "2px 6px",
                          borderRadius: "10px",
                          fontWeight: "600",
                        }}
                      >
                        {cat}
                      </span>
                    ))}
                  </div>
                )}

                {/* PRICES */}
                <div className="mt-1">
                  <div
                    className="text-muted"
                    style={{ textDecoration: "line-through", fontSize: "0.8rem" }}
                  >
                    {formatPriceDT(product.displayPrice)}
                  </div>
                  <div className="fw-bold" style={{ color: "#ff1fb2", fontSize: "1.1rem" }}>
                    {formatPriceDT(product.discountedPrice)}
                  </div>
                </div>

                {/* PROMO BADGE */}
                <span
                  className="badge mt-2"
                  style={{
                    backgroundColor: "#ff1fb2",
                    color: "#fff",
                    fontSize: "0.65rem",
                  }}
                >
                  -{product.promo_percentage || 0}%
                </span>
              </div>
            </div>
          </Link>

        );
      })}
    </div>
  );
}